/**
 * Created by mac on 12/21/20
 */

const FamiliesHelper = {
    ValuableFamily: function (id, options) {
        options = options || {};

        return {
            type: "valuables",
            id,
            extraBundles: options.extraBundles,
            units: options.amounts.map((value, stage) => {
                const res = {
                    value,
                    price: value
                };

                if (options.collectible && value !== 0) {
                    res.collectible = options.collectible;
                }

                if (options.pulsing) {
                    res.pulsing = true;
                }

                if (options.unmergeable) {
                    res.unmergeable = true;
                }

                if (options.shineFrom && stage >= options.shineFrom) {
                    res.shine = true;
                }

                if (options.draggable) {
                    res.draggable = true;
                }

                if (options.unitsLibrary) {
                    res.unitsLibrary = true;
                }

                return res;
            })
        };
    },

    EnergyCupFamily: function (total, options) {
        options = options || {};

        const units = [];
        const config = CupsConfig[options.code] || {};
        const stages = total || 1;

        for (let i = 0; i < stages; i++) {
            const stageConfig = config[`stage${i}`] || {};
            let lockable;
            if (stageConfig.lockDuration) {
                lockable = { duration: stageConfig.lockDuration };
            }
            units.push({
                price: stageConfig.price || config.price,
                cup: {
                    amount: stageConfig.amount || config.amount,
                    probabilities: stageConfig.probabilities || config.probabilities,
                    units: CupsConfig.parseRewards(stageConfig.rewards || config.rewards),
                    ordersOnly: options.ordersOnly,
                    openedOnly: options.openedOnly
                },
                draggable: options.draggable,
                unmergeable: options.unmergeable,
                unitsLibrary: options.unitsLibrary,
                lockable
            });
        }

        return {
            unmergeable: options.unmergeable,
            type: "energycup",
            units
        };
    },

    ChooseLineFamily: function (total, options) {
        options = options || {};

        const units = [];
        const stages = total || 1;
        const choosesByStages = options.choosesByStages || [];

        for (let i = 0; i < stages; i++) {
            units.push({
                unmergeable: options.unmergeable,
                draggable: options.draggable,
                choose: {
                    variants: choosesByStages[i] || []
                }
            });
        }

        return {
            unmergeable: options.unmergeable,
            type: "chooseline",
            units
        };
    },

    RainbowFamily: function (total, options) {
        const units = [];
        const stages = total || 1;

        for (let i = 0; i < stages; i++) {
            units.push({
                unmergeable: options.unmergeable,
                rainbow: true
            });
        }

        return {
            booster: true,
            type: "rainbow",
            units
        };
    },

    PinFamily: function (total, options) {
        const units = [];
        const stages = total || 1;

        for (let i = 0; i < stages; i++) {
            units.push({
                unmergeable: options.unmergeable,
                pin: true
            });
        }

        return {
            booster: true,
            type: "pin",
            units
        };
    },

    ScissorsFamily: function (total, options) {
        options = options || {};

        const units = [];
        const stages = total || 1;

        for (let i = 0; i < stages; i++) {
            units.push({
                scissors: {
                    charges: options.charges || 1
                }
            });
        }

        return {
            booster: true,
            type: "scissors",
            units
        };
    },

    AmplifierFamily: function (total, options) {
        options = options || {};

        const units = [];
        const stages = total || 1;

        for (let i = 0; i < stages; i++) {
            units.push({
                amplifier: {
                    charges: options.charges[i]
                }
            });
        }

        return {
            booster: true,
            type: "amplifier",
            units
        };
    },

    EnergyCardFamily: function (total, options) {
        options = options || {};

        const units = [];
        const stages = total || 1;

        for (let i = 0; i < stages; i++) {
            units.push({
                energycard: {
                    charges: options.charges[i]
                }
            });
        }

        return {
            booster: true,
            type: "energycard",
            units
        };
    },

    HourglassFamily: function (total, options) {
        options = options || {};

        const units = [];
        const stages = total || 1;

        for (let i = 0; i < stages; i++) {
            units.push({
                unmergeable: i === stages - 1,
                hourglass: {
                    duration: options.durations[i],
                    targets: options.targets
                }
            });
        }

        return {
            booster: true,
            type: "hourglass",
            units
        };
    },

    SpecialUnitFamily: function (unit, options) {
        options = options || {};

        return {
            type: options.type,
            units: Array.isArray(unit) ? unit : [unit],
            oneViewForStages: options.oneViewForStages,
            locators: options.locators,
            extraBundles: options.extraBundles,
            localization: options.localization
        };
    },

    ThirdElementUnitFamily: function () {
        return {
            type: "thirdelement",
            units: [{
                unmergeable: true,
                thirdelement: true
            }, {
                unmergeable: true,
                thirdelement: true
            }],
            localization: false
        };
    },

    ResourceFamily: function (total, options) {
        options = options || {};

        const units = [];

        for (let i = 0; i < total; i++) {
            const createPrize = options.createPrize;

            units.push({
                price: (options.basicPrice || 13) * Math.pow(2, i),
                createPrize,
                unitsLibrary: options.unitsLibrary
            });
        }

        return {
            type: "resource",
            sideQuest: options.sideQuest,
            units
        };
    },

    GeneratorFamily: function (options) {
        const units = [];
        const config = OrdersAlgoConfig.generators[options.code];

        config.stages.forEach((stage, i) => {
            if (stage.drop) {
                const spawn = stage.spawn || config.spawn || 1;
                const destroyAfterDrops = stage.destroyAfterDrops !== undefined ? stage.destroyAfterDrops : config.destroyAfterDrops;
                const cooldown = stage.cooldown || config.cooldown || 0;
                const showProgress = spawn > 1 && destroyAfterDrops;
                const drop = stage.drop;
                const power = stage.power || 100;

                const isLast = i === config.stages.length - 1;

                units.push({
                    unmergeable: isLast,
                    generator: {
                        drop,
                        power,
                        weights: stage.weights,
                        autoMine: config.autoMine,
                        spawn,
                        energy: config.energy !== undefined ? config.energy : 1,
                        cooldown: destroyAfterDrops ? undefined : `${cooldown} minutes`,
                        destroyAfterDrops,
                        showProgress
                    },
                    price: (options.basicPrice || 13) * Math.pow(2, i)
                });
            } else {
                units.push({
                    price: (options.basicPrice || 13) * Math.pow(2, i)
                });
            }
        });

        return {
            resource: options.resource,
            sideQuest: options.sideQuest,
            type: "generator",
            units
        };
    }
};

if (typeof cc === "undefined") {
    module.exports = FamiliesHelper;
}
